import JsonManager from './JsonManager';
import ImageManager from './ImageManager';

class CarouselManager {
  constructor(id = '', file_path = '') {
    if (id !== '') {
      this.id = id;
      this.project = JsonManager.getProject(id);
      this.images = new ImageManager(id, file_path);
      this.content = this.project.content;
    }
  }

  static getAllProjects() {
    const pjs = [];
    const projects = JsonManager.getAllProjects();
    const ids = Object.keys(projects);

    for (let i = 0; i < ids.length; i += 1) {
      const id = ids[i];

      pjs.push(projects[id]);
    }

    return pjs;
  }

  getDefaultImage() {
    return this.images.getDefaultImage();
  }

  getLargeImages() {
    const imageList = [];
    for (let i = 0; i < this.content.length; i += 1) {
      imageList.push(this.images.getProjectLargeImageAt(i));
    }
    return imageList;
  }

  getTinyImages() {
    const imageList = [];
    for (let i = 0; i < this.content.length; i += 1) {
      imageList.push(this.images.getProjectTinyImageAt(i));
    }
    return imageList;
  }

  getThumbnails() {
    const imageList = [];
    for (let i = 0; i < this.content.length; i += 1) {
      imageList.push(this.images.getProjectThumbnailImageAt(i));
    }
    return imageList;
  }

  getAlt(id) {
    return this.project.alts[id];
  }

  getTitle() {
    return this.project.title;
  }

  getSubtitle() {
    return this.project.subtitle;
  }

  getVideoURL(id) {
    return this.project.videos[id];
  }

  getVideoObject(index) {
    const id = this.content[index];
    if (this.getVideoURL(id)) {
      const videoURL = `${this.getVideoURL(id)}?wmode=transparent`;

      return {
        embedUrl: videoURL,
      };
    }
    return {};
  }

  getButtons() {
    const buttons = [];
    const btns = this.project.buttons;

    for (let i = 0; i < btns.length; i += 1) {
      const button = btns[i];
      button.link = button.link === 'id' ? this.id : button.link;
      buttons.push({ button });
    }
    return { buttons };
  }

  getImageObject(index) {
    const originals = this.getLargeImages();
    const thumbnails = this.getThumbnails();
    const tinyImages = this.getTinyImages();
    const id = this.content[index];
    const alt = this.getAlt(id);

    return {
      thumbnail: thumbnails[index],
      original: originals[index],
      tiny: tinyImages[index],
      title: this.getTitle(),
      subtitle: this.getSubtitle(),
      id: this.id,
      alt,
    };
  }

  getCarouselImageManifest() {
    const imageList = [];
    for (let i = 0; i < this.content.length; i += 1) {
      imageList[i] = Object.assign(
        this.getImageObject(i),
        this.getVideoObject(i),
        this.getButtons(),
      );
    }
    return imageList;
  }
}

export default CarouselManager;



// WEBPACK FOOTER //
// ./src/managers/CarouselManager.js